export function cappedCount(num: number): string {
  return num >= 1000 ? '1K+' : num.toString();
}
